import React, { useRef, useState } from 'react';
import { CREDIT_REQUEST_ROUTES } from '@/navigators/routes';
import {
  CreditRequestFormContent,
  CreditRequestFormContentHandle,
} from '@/components/credit-request/credit-request-form-content';
import { CreditRequestStackParams } from '@/navigators/types';
import { ModalContainer } from '@/components/modal-container';
import { StackScreenProps } from '@react-navigation/stack';

export type Props = StackScreenProps<
  CreditRequestStackParams,
  CREDIT_REQUEST_ROUTES.Base
>;

export const CreditRequestFormScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const {
    params: {
      confirmOnExit,
      eligibleForCredit,
      existingBatchLineItem,
      guaranteed,
      invoiceQuantityMap,
      itemDetail,
      multiRequest,
      onClose,
      onSuccess,
      orderInvoiceUUID,
    },
  } = route;
  const contentRef = useRef<CreditRequestFormContentHandle>(null);
  const [showCamera, setShowCamera] = useState(false);

  const closeAndCleanup = () => {
    navigation.goBack();
    onClose?.();
  };

  const navigationHeaderProps = showCamera
    ? { containerStyle: { paddingTop: 0 }, hideHeader: true }
    : {
        onBackPress: () => {
          if (contentRef.current) {
            contentRef.current.attemptClose(closeAndCleanup);
          } else {
            closeAndCleanup();
          }
        },
      };

  return (
    <ModalContainer navigationHeaderProps={navigationHeaderProps}>
      <CreditRequestFormContent
        confirmOnExit={confirmOnExit}
        eligibleForCredit={eligibleForCredit}
        existingBatchLineItem={existingBatchLineItem}
        guaranteed={guaranteed}
        invoiceQuantityMap={invoiceQuantityMap}
        itemDetail={itemDetail}
        multiRequest={multiRequest}
        onShowCameraChange={setShowCamera}
        onSuccess={(batchLineItem) => {
          onSuccess(batchLineItem);
          navigation.goBack();
        }}
        orderInvoiceUUID={orderInvoiceUUID}
        ref={contentRef}
      />
    </ModalContainer>
  );
};
